import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "../locales",
    true,
    /[A-Za-z0-9-_,\s]+\.js$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default;
    }
  });
  return messages;
}

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "zh",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "zh",
  messages: loadLocaleMessages(),
});
//  處理接口字段
i18n.tObject = (object, name) => {
  if (!object) return null
  let cn = object[name + "c"] || object[name + 'Cn']
  let tc = object[name + "Tc"]
  let pt = object[name + "p"] || object[name + 'Pt']
  let en = object[name + "p"] || object[name + 'En']
  let normal = object[name]

  if (i18n.locale === 'zh') {
    return cn || tc || normal || en || pt
  } else if (i18n.locale === "pt") {
    return pt || en || cn || tc || normal
  } else {
    return en || pt || cn || tc || normal
  }
}
export default i18n;

export function changeLanguage(lang) {
  i18n.locale = lang;
}
